import { IClubOfficer, INewClubOfficerForm } from '../../../../../../store/admin/clubs/store';

import { IOption } from '../../../../../../components/Select/Select';

export const getOfficerPermissionsValue = (
  officer: INewClubOfficerForm | IClubOfficer
): IOption => {
  const { isAdmin, isStaff, isOwner } = officer;

  return isOwner
    ? { label: 'OWNER', value: 'OWNER' }
    : isAdmin
    ? { label: 'ADMIN', value: 'ADMIN' }
    : isStaff
    ? { label: 'STAFF', value: 'STAFF' }
    : { label: 'NONE', value: 'NONE' };
};
